export default function Marquee({ items, className = "" }) {
  const row = (ariaHidden) => (
    <div className="inline-flex items-center shrink-0" aria-hidden={ariaHidden || undefined}>
      {items.map((t, i) => (
        <span key={i} className="inline-flex items-center font-display font-bold text-sm md:text-lg tracking-[0.18em] uppercase">
          <span className="px-6">{t}</span>
          <span className="text-volt">//</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee border-y border-white/10 py-4 ${className}`}>
      <div className="marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
